import React from 'react';

import {
  PageWrapper,
  Panel,
  Toggle,
  Placeholder,
  useNotification,
  Flex,
  LeftHalfLayout,
  RightHalfLayout,
  Explainer
} from '@ubisend/pulse-components';
import { AppWidget } from '@ubisend/pulse-bot';
import { useQuery, useMutation, useQueryClient } from '@ubisend/pulse-hooks';

import { updateSettings } from '../api/index';

const followUpMessages = [
  {
    content: {
      text: 'When are you open?'
    },
    direction: 'toServer',
    type: 'standard'
  },
  {
    content: {
      text: 'Our opening hours are 9pm to 5pm on weekdays.'
    },
    direction: 'toClient',
    type: 'standard'
  },
  {
    content: {
      text: 'Was this helpful?',
      responses: [
        {
          label: 'Yes',
          postback: 'Yes'
        },
        {
          label: 'No',
          postback: 'No'
        }
      ]
    },
    direction: 'toClient',
    type: 'quick-reply'
  },
  {
    content: {
      text: 'Yes'
    },
    direction: 'toServer',
    type: 'standard'
  },
  {
    content: {
      text: 'Great, glad I could help. Feel free to ask me any additional questions.'
    },
    direction: 'toClient',
    type: 'standard',
    composer: { type: 'hidden' }
  }
];

const FaqSettings = () => {
  const { showSuccess } = useNotification();

  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ['faqs/settings']
  });

  const { mutate: updateSetting } = useMutation({
    mutationFn: updateSettings,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries('faqs/settings');

      if ('has_follow_ups_enabled' in variables) {
        showSuccess(
          `FAQ follow up successfully ${
            variables.has_follow_ups_enabled ? 'enabled' : 'disabled'
          }.`
        );
      } else if ('has_self_reflection_enabled' in variables) {
        showSuccess(
          `FAQ self-reflection successfully ${
            variables.has_self_reflection_enabled ? 'enabled' : 'disabled'
          }.`
        );
      }
    }
  });

  return (
    <PageWrapper
      header="FAQ Settings"
      subheader="Configure FAQ behaviour for your chatbot">
      {!data && <Placeholder ySpace />}
      {data && (
        <Flex>
          <LeftHalfLayout>
            <Flex col ySpace>
              <Panel
                header="Follow Up"
                actions={
                  <Toggle
                    on={data.data.has_follow_ups_enabled}
                    handleToggleChange={() => {
                      updateSetting({
                        has_follow_ups_enabled:
                          !data.data.has_follow_ups_enabled
                      });
                    }}
                  />
                }>
                <Explainer mt mb>
                  When FAQ follow up is enabled, subscribers are asked to rate
                  the helpfulness of the FAQ answer they receive.
                </Explainer>
              </Panel>
              <Panel
                header="Self-Reflection"
                actions={
                  <Toggle
                    on={data.data.has_self_reflection_enabled}
                    handleToggleChange={() => {
                      updateSetting({
                        has_self_reflection_enabled:
                          !data.data.has_self_reflection_enabled
                      });
                    }}
                  />
                }>
                <Explainer mt mb>
                  When FAQ self-reflection is enabled, the chatbot reviews its
                  own FAQ answers to improve accuracy. Just be aware that
                  responses might be a bit slower.
                </Explainer>
              </Panel>
            </Flex>
          </LeftHalfLayout>
          <RightHalfLayout>
            <Flex middle>
              <AppWidget
                name={'Follow Up Example'}
                messages={followUpMessages}
              />
            </Flex>
          </RightHalfLayout>
        </Flex>
      )}
    </PageWrapper>
  );
};

export default FaqSettings;
